<div>
  <dx-report-viewer [reportUrl]="reportId()" height="70vh" cssClass="myViewer">
    <dxrv-request-options
      [invokeAction]="invokeAction"
      [host]="hostUrl"
    ></dxrv-request-options>
    <dxrv-tabpanel-settings
      [width]="500"
      position="Left"
    ></dxrv-tabpanel-settings>
    <dxrv-export-settings [useSameTab]="true" [useAsynchronousExport]="true">
    </dxrv-export-settings>
    <dxrv-search-settings [useAsyncSearch]="false"></dxrv-search-settings>
    <dxrv-callbacks
      (BeforeRender)="onBeforeRender($event)"
      (CustomizeMenuActions)="CustomizeMenuActions($event)"
      (CustomizeExportOptions)="CustomizeExportOptions($event)"
      (OnExport)="OnExport($event)"
    >
    </dxrv-callbacks>
  </dx-report-viewer>
</div>
